import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";

export default function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleNavigateToAccount = () => {
    navigate("/account");
    setIsOpen(false);
  };

  const handleNavigateToChangePassword = () => {
    navigate("/change-password");
    setIsOpen(false);
  };

  const handleLogout = () => {
    navigate("/login");
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className="flex items-center space-x-2 cursor-pointer"
        onClick={toggleDropdown}
      >
        <div className="w-10 h-10 rounded-lg">
          <Avatar
            src="/path-to-avatar.jpg"
            
          />
        </div>
        <span className="truncate whitespace-nowrap overflow-hidden text-white w-[50px] sm:truncate sm:whitespace-nowrap sm:overflow-hidden md:truncate md:whitespace-nowrap md:overflow-hidden lg:whitespace-normal lg:overflow-visible lg:text-clip lg:w-full">
          {"User"}
        </span>
      </div>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-72 rounded-md shadow-lg bg-gray-800 ring-1 ring-black ring-opacity-5 z-50">
          <div className="py-1">
            <div className="px-4 py-3 border-b border-gray-700">
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-lg mr-3">
                  <Avatar
                    src="/path-to-avatar.jpg"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-white">
                    {"User"}
                  </p>
                  <p className="text-xs text-gray-400">
                    {"user@example.com"}
                  </p>
                </div>
              </div>
            </div>
            <button
              onClick={handleNavigateToAccount}
              className="block w-full text-left px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
            >
              My Account
            </button>
            <button
              onClick={handleNavigateToChangePassword}
              className="block w-full text-left px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
            >
              Change Password
            </button>
            <button
              onClick={handleLogout}
              className="block w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-gray-700 hover:text-red-300"
            >
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
